const production = {
    env: process.env.REACT_APP_ENV,
    xApiKeyValues: process.env.X_API_KEY_VALUES

};

const qa = {
    env: process.env.REACT_APP_ENV,
    xApiKeyValues: process.env.X_API_KEY_VALUES
};

const development = {
    env: process.env.REACT_APP_ENV,
};

let config = '';

switch (process.env.REACT_APP_ENV) {
    case 'prod':
        config = production;
        break;
    case 'dev':
        config = development;
        break;
    case 'qa':
        config = qa;
        break;
    default :
        break;
}

export default { ...config };